import { useEffect, useState } from "react";
import { masterFetch } from "./masterApi";
import MasterLayout from "./MasterLayout";

export default function MasterAudit() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    masterFetch("/audit-log?limit=200").then((d) => setRows(d.entries || [])).catch((e) => setErr(e.message));
  }, []);

  return (
    <MasterLayout>
      <h1 style={{ margin: "0 0 4px", fontSize: 26, letterSpacing: -0.5 }}>Audit log</h1>
      <div style={{ opacity: 0.55, fontSize: 13, marginBottom: 24 }}>
        Every master action, in chronological order.
      </div>

      {err && <div style={{ padding: 14, background: "rgba(255,80,90,0.1)", border: "1px solid rgba(255,80,90,0.4)", color: "#ff7886", borderRadius: 8, fontSize: 13 }}>{err}</div>}

      <div data-testid="master-audit-log" style={{ background: "#0f0a1c", border: "1px solid #1f1232", borderRadius: 12, overflow: "hidden" }}>
        {rows.length === 0 ? (
          <div style={{ padding: 20, opacity: 0.4, fontSize: 13 }}>No master actions yet.</div>
        ) : rows.map((r) => (
          <div key={r.id} style={{ padding: "12px 16px", borderBottom: "1px solid #1a1029", fontSize: 13 }}>
            <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
              <span style={{ opacity: 0.5, fontSize: 11, minWidth: 140 }}>{new Date(r.at).toLocaleString()}</span>
              <span style={{ color: "#a855f7", fontWeight: 500 }}>{r.action}</span>
              <span style={{ opacity: 0.5, fontSize: 11, marginLeft: "auto" }}>tenant: {r.tenant_id?.slice(0, 8)}</span>
            </div>
            {r.details && Object.keys(r.details).length > 0 && (
              <pre style={{ margin: "6px 0 0", opacity: 0.55, fontSize: 11, background: "transparent" }}>
                {JSON.stringify(r.details, null, 2)}
              </pre>
            )}
          </div>
        ))}
      </div>
    </MasterLayout>
  );
}
